if (!customElements.get('holiday-bundle')) {
  customElements.define('holiday-bundle', class HolidayBundle extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-bundle-variants]');
      if (!data) return;

      this.product = JSON.parse(data.textContent);
      this.variant = this.product.variants.find((variant) => variant.id === this.product.selectedId);
      this.options = [...this.variant.options];
      this.quantityInput = this.querySelector('[name="quantity"]');
      this.variantInput = this.querySelector('[data-bundle-variant-id]');
      this.submitButton = this.querySelector('[name="add"]');
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const swatch = event.target.closest('.nelko-pdp-summary__swatch');
        if (!swatch || swatch.disabled) return;
        this.options[Number(swatch.dataset.optionPosition) - 1] = swatch.dataset.optionValue;
        this.updateVariant();
      }, { signal: this.controller.signal });
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-bundle-option]')) {
          this.options[Number(event.target.dataset.optionPosition) - 1] = event.target.value;
          this.updateVariant();
        }
      }, { signal: this.controller.signal });
      this.updateVariant();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    updateVariant() {
      this.variant = this.product.variants.find((variant) => variant.options.every((value, index) => value === this.options[index]));
      this.variantInput.value = this.variant?.id || '';
      this.variantInput.disabled = !this.variant;
      this.submitButton.disabled = !this.variant?.available;
      this.submitButton.querySelector('span').textContent = this.variant
        ? (this.variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel)
        : this.dataset.unavailableLabel;

      this.querySelectorAll('.nelko-pdp-summary__swatch').forEach((swatch) => {
        const position = Number(swatch.dataset.optionPosition) - 1;
        const active = this.options[position] === swatch.dataset.optionValue;
        const available = this.product.variants.some((variant) => variant.available && variant.options.every((value, index) => value === (index === position ? swatch.dataset.optionValue : this.options[index])));
        swatch.classList.toggle('is-active', active);
        swatch.classList.toggle('is-disabled', !available);
        swatch.setAttribute('aria-pressed', String(active));
        swatch.disabled = !available;
        swatch.setAttribute('aria-disabled', String(!available));
      });
      this.querySelectorAll('[data-bundle-option]').forEach((select) => {
        select.value = this.options[Number(select.dataset.optionPosition) - 1];
      });

      const detail = this.querySelector('[data-bundle-detail]');
      detail.href = this.variant ? `${this.product.url}?variant=${this.variant.id}` : this.product.url;
      this.quantityInput.value = this.variant?.quantityRule?.min || 1;
    }
  });
}
